/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReportByIdRecipientEmailResponse } from './report-by-id-recipient-email-response';


export interface ReportByIdResponse { 
    id: string;
    name: string;
    exportFrequencyId: number;
    exportTypeIds: Array<number>;
    recipientEmails: Array<ReportByIdRecipientEmailResponse>;
    accountIds?: Array<string> | null;
    isSeparateProfitByAccounts: boolean;
}

